import { Box, Checkbox, FormControlLabel, IconButton, Tooltip } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import DropDownMenuProfile from '../../components/DropDown/DropDownMenuProfile';
import eyeIcon from '../../assets/eye-solid.svg';
import DeleteModal from '../Modals/DeleteModal';
import HolidayDetailModal from './component/HolidayDetailModal';
import TablePagination from '@mui/material/TablePagination';
import { useRef } from 'react';
import { useEffect } from 'react';
import cancelIcon from '../../assets/icon/cancelIcon.svg';
import checkIcon from '../../assets/icon/checkIcon.svg';
import { permissionObj } from '../../Helpers/permission';
import { useSelector } from 'react-redux';
import NotInformation from '../../components/NotInformation';
import DropDownMenuItem from "../../components/DropDown/DropDownMenuItem";

const Holiday = () => {
    const { t } = useTranslation();
    const [approveHoliday, setApproveHoliday] = useState(false);
    const [deniedHoliday, setDeniedHoliday] = useState(false);
    const [holidayDetail, setHolidayDetail] = useState(false);
    const [holidayDetailData, setHolidayDetailData] = useState('');
    const [topHeaderHeight, setTopHeaderHeight] = useState('');
    const headerSectionHeight = useRef(null);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [openMenu, setOpenMenu] = useState(null);

    const handleMenuToggle = (menuId) => {
        setOpenMenu(prevMenu => (prevMenu === menuId ? null : menuId));
    };

    const handleClose = () => {
        setOpenMenu(null);
    };

    useEffect(() => {
        if (headerSectionHeight.current) {
            const height = headerSectionHeight.current.clientHeight;
            setTopHeaderHeight(height);
        }
    }, []);
    return (
        <>
            <div className='top_section_wrapper' ref={headerSectionHeight}>
                <div className='head'>
                    <div className='headLeft'>
                        <h2>{t('holidays')?.toUpperCase()}</h2>
                    </div>

                    <div className='d-flex align-items-center gap-2'>
                        {(DEV ||
                            (permission?.includes(permissionObj?.WEB_HOLIDAY_CREATE)) && (
                                <button className='add-btn-1'>
                                    <i className='fa fa-plus' aria-hidden='true'/>
                                    {t('add')}
                                </button>
                            ))}

                        {(DEV ||
                            (permission?.includes(permissionObj?.WEB_HOLIDAY_DELETE) )&& (
                                <button className="btn-icon-delete">
                                    <i class='fa fa-trash-o' aria-hidden='true'/>
                                    {t('delete')}
                                </button>
                            ))}
                    </div>
                </div>
            </div>
            <Box className='scroll_bar_fit_hight_wrapper' sx={{ height: `calc(100vh - ${topHeaderHeight + 70}px )` }}>
                <div className='holiday_table px-1 mt-1 w-pt'>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].length > 0 ? (
                        <table className='w-100'>
                            <thead style={{ position: 'sticky', top: 0, background: 'white' }}>
                                <th className='first_head'>
                                    <Tooltip title={t('de_/_select_all').toUpperCase()} placement='top'>
                                        <Checkbox size='small' />
                                    </Tooltip>

                                    {t('employee')}
                                </th>
                                <th>{t('from')}</th>
                                <th>{t('to')}</th>
                                <th>{t('requested_at')}</th>
                                <th>{t('total_days')}</th>
                                <th>{t('status')}</th>
                                <th>{t('details')}</th>
                                <th className='last'>{t('option')}</th>
                            </thead>
                            <tbody>
                                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item, index) => {
                                    return (
                                        <tr>
                                            <td className='first align-middle'>
                                                <Checkbox size='small' />
                                                Luis Enrique Cornejo Arreola
                                            </td>
                                            <td style={{ maxWidth: 250 }}>10/01/2023</td>
                                            <td>20/01/2023</td>
                                            <td>01/01/2023 00:00:00</td>
                                            <td style={{ maxWidth: 250 }}> 10 DÍAS </td>
                                            <td style={{ fontWeight: 'bold', color: '#707070' }}>
                                                PENDINGT TO VALIDATE
                                            </td>
                                            <td>
                                                <IconButton
                                                    onClick={() => {
                                                        setHolidayDetailData('data here');
                                                        setHolidayDetail(true);
                                                    }}
                                                >
                                                    <img src={eyeIcon} alt='eye' />
                                                </IconButton>
                                            </td>
                                            <td className='last_tr'>
                                                <DropDownMenuProfile
                                                    openMenu={openMenu}
                                                    handleMenuToggle={handleMenuToggle}
                                                    menuId={`menu-${index}`}
                                                >
                                                    <DropDownMenuItem
                                                        index={index}
                                                        handleClose={handleClose}
                                                        name={t('approve_holiday')}
                                                        click={() => setApproveHoliday(true)}
                                                        icon={<img src={checkIcon} alt='check' className={"w-18px h-18px"}/>}
                                                    />
                                                    <DropDownMenuItem
                                                        index={index}
                                                        handleClose={handleClose}
                                                        name={t('approve_holiday')}
                                                        click={() => setDeniedHoliday(true)}
                                                        icon={<img src={cancelIcon} alt='cancle' className={"w-18px h-18px"}/>}
                                                    />
                                                </DropDownMenuProfile>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    ) : (
                        <NotInformation text={t('no_information')} card={true} />
                    )}
                </div>
            </Box>

            <Box className='center-pagination'>
                <TablePagination
                    component='div'
                    rowsPerPageOptions={[10, 15, 20, 30]}
                    labelRowsPerPage={t('holiday_per_page')}
                    className='custom-pagination'
                />
            </Box>
            <DeleteModal
                show={approveHoliday}
                onHide={() => setApproveHoliday(false)}
                title_modal={t('approve')}
                description='Do you want to approve the holidays? To apply the action, please confirm it'
            />
            <DeleteModal
                show={deniedHoliday}
                onHide={() => setDeniedHoliday(false)}
                title_modal={t('denied')}
                description='Do you want to denied the holiday? To apply the action, please confirm it.'
            />
            <HolidayDetailModal
                show={holidayDetail}
                onHide={() => setHolidayDetail(false)}
                titleModal={'holiday_details'}
                data={holidayDetailData}
            />
        </>
    );
};

export default Holiday;
